export enum PropertyDisplayFormat {
  Date = "Date",
  DateTime = "DateTime",
  Currency = "Currency",
  Link = "Link",
  PhoneLink = "PhoneLink",
  EmailLink = "EmailLink",
}
